/**
 * Component: M1 Hero
 * 
 */
'use strict';

export class Hero
{
  constructor()
  {
    this.selectors = {
      component:    $('.c-v4-m1-hero'),
      main:         $('.c-v4-m1-hero--main'),
      spinner:      $('.c-v4-m1-hero--main h1 .spinner'),
      spinner_item: $('.c-v4-m1-hero--main h1 .spinner-item'),
      lottie:       $('.c-v4-m1-hero--lottie .lottie-wrapper'),
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.set_lottie_height();
    this.init_spinner();
  }

  /**
   * Set Lottie height
   *
   */
  set_lottie_height()
  {
    this.selectors.lottie.outerHeight( this.selectors.main.outerHeight() ).addClass('ready');
  }

  /**
   * Init text spinners
   * 
   */
  init_spinner()
  {
    let _self = this;

    this.selectors.spinner.each(function()
    {
      let _el     = $(this),
          spin_to   = parseInt($(this).attr('data-spin-to')),
          interval  = parseFloat($(this).attr('data-interval')),
          total     = $(this).find(_self.selectors.spinner_item).length - 1;

      setInterval(function()
      {
        spin_to = ( spin_to >= total ) ? 0 : spin_to + 1;

        _el.attr('data-spin-to', spin_to);

      }, interval * 1000);
    });
  }
}